// Mapping des noms de régions vers leurs codes
// Codes officiels des régions françaises depuis 2016

export const REGION_NAME_TO_CODE: Record<string, string> = {
  // France métropolitaine (codes 01 à 11)
  'Auvergne-Rhône-Alpes': '84',
  'Bourgogne-Franche-Comté': '27',
  'Bretagne': '53',
  'Centre-Val de Loire': '24',
  'Corse': '94',
  'Grand Est': '44',
  'Hauts-de-France': '32',
  'Île-de-France': '11',
  'Normandie': '28',
  'Nouvelle-Aquitaine': '75',
  'Occitanie': '76',
  'Pays de la Loire': '52',
  'Provence-Alpes-Côte d\'Azur': '93',

  // Départements et régions d'outre-mer
  'Guadeloupe': '01',
  'Martinique': '02',
  'Guyane': '03',
  'La Réunion': '04',
  'Mayotte': '06',

  // Anciennes régions (pour compatibilité)
  'Alsace': '44', // → Grand Est
  'Aquitaine': '75', // → Nouvelle-Aquitaine
  'Auvergne': '84', // → Auvergne-Rhône-Alpes
  'Basse-Normandie': '28', // → Normandie
  'Bourgogne': '27', // → Bourgogne-Franche-Comté
  'Champagne-Ardenne': '44', // → Grand Est
  'Franche-Comté': '27', // → Bourgogne-Franche-Comté
  'Haute-Normandie': '28', // → Normandie
  'Languedoc-Roussillon': '76', // → Occitanie
  'Limousin': '75', // → Nouvelle-Aquitaine
  'Lorraine': '44', // → Grand Est
  'Midi-Pyrénées': '76', // → Occitanie
  'Nord-Pas-de-Calais': '32', // → Hauts-de-France
  'Picardie': '32', // → Hauts-de-France
  'Poitou-Charentes': '75', // → Nouvelle-Aquitaine
  'Rhône-Alpes': '84', // → Auvergne-Rhône-Alpes
};

/**
 * Extrait le code région depuis le champ context de l'API adresse.data.gouv.fr
 * Format du context: "departement, ville, région"
 * Exemple: "75, Paris, Île-de-France"
 */
export function extractRegionCode(context: string): string | null {
  if (!context) return null;

  // Le context est au format: "departement, ville, région"
  const parts = context.split(',').map(part => part.trim());

  // La région est le dernier élément
  const regionName = parts[parts.length - 1];

  if (!regionName) return null;

  // Chercher le code correspondant
  return REGION_NAME_TO_CODE[regionName] || null;
}

/**
 * Obtient le nom de la région depuis le code
 */
export function getRegionNameByCode(code: string): string | null {
  const entry = Object.entries(REGION_NAME_TO_CODE).find(([_, regionCode]) => regionCode === code);
  return entry ? entry[0] : null;
}
